<script>
  import axios from "axios";
  import { onMount, getContext } from "svelte";
  import getCsrfToken from "common/utils/getCsrfToken";
  import camelToSnakeCase from "common/utils/camelToSnakeCase";
  import {
    show,
    addNotification,
    closeAllNotifications,
  } from "common/notifications/Notifications";
  import Tooltip from "common/components/Tooltip";
  import Spinner from "common/components/Spinner";

  export let url = "";
  export let type;

  const t = getContext("STRINGS");

  let image;
  let timer;

  let width = 550;
  $: height = Math.min(width * 0.454545, 250);

  const INTERVAL = 60000;

  const typeLocalizationDescriptionKey = `${camelToSnakeCase(
    type
  )}_description`;

  let loading;

  const description =
    typeLocalizationDescriptionKey !== t(typeLocalizationDescriptionKey)
      ? t(typeLocalizationDescriptionKey)
      : null;

  function getBase64() {
    loading = axios
      .get(url, {
        params: { type },
        headers: {
          "X-CSRF-Token": getCsrfToken(),
          "Content-Type": "application/json; charset=utf-8",
          Accept: "application/json; charset=utf-8",
        },
        credentials: "same-origin",
      })
      .then((res) => {
        image = res.data.image_base64;
        return image;
      })
      .catch((err) => {
        show(err, {
          title: "Error",
          type: "error",
          description: `Chart '${type}' can't be fetched.`,
        });
      });
    return loading;
  }

  onMount(async () => {
    await getBase64();
    const delay = Math.floor(Math.random() * 5000) + 1000;
    setTimeout(() => {
      timer = setInterval(getBase64, INTERVAL);
    }, delay);
    return () => clearInterval(timer);
  });
</script>

<style>
  .chart-wrapper {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 5px;
    border-radius: 5px;
    background: #fff;
  }
  .tooltip-wrapper {
    position: absolute;
    top: 10px;
    right: 10px;
  }
  .spinner-wrapper {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
  .chart-image {
    display: block;
    border: none;
    background: #fefefe;
    max-width: 100%;
    height: auto;
  }
  .ratio-placeholder {
    height: 0;
    padding-bottom: 44%;
    padding-bottom: calc(250 / 550 * 100%);
    overflow: hidden;
  }
</style>

<div class="tc-card chart-wrapper">
  <div class="ratio-placeholder" />
  {#if image}
    <img alt="Chart" class="chart-image" src={image} />
  {/if}
  {#await loading}
    <div class="spinner-wrapper">
      <Spinner />
    </div>
  {/await}

  {#if description}
    <div class="tooltip-wrapper">
      <Tooltip>{description}</Tooltip>
    </div>
  {/if}
</div>
